import { toTitleCase } from "../Utils";

const AttributeTypes = {
    STRING: "string",
    NUMBER: "number", 
    DATE: "date",
    BOOLEAN: "boolean",
};

const AttributeTypeLabels = {
    [AttributeTypes.STRING]: "String",
    [AttributeTypes.NUMBER]: "Number",
    [AttributeTypes.DATE]: "Date",
    [AttributeTypes.BOOLEAN]: "Boolean",
    [AttributeTypes.SELECT]: "Select",
};

const AttributeTypeOptions = Object.values(AttributeTypes).map(type => ({
    label: AttributeTypeLabels[type],
    value: type,
}));

const getAttributeTypeLabel = (type) => {
    return AttributeTypeLabels[type] || toTitleCase(type);
};

const getAttributeTypeOptions = () => {
    return AttributeTypeOptions;
};

const convertAttributeValueToType = (value, type) => {
    if (value === null || value === undefined) {
        return value;
    }

    switch (type) {
        case AttributeTypes.BOOLEAN:
            return typeof value === 'string' ? value === 'true' : Boolean(value);
        case AttributeTypes.NUMBER:
            return typeof value === 'string' ? Number(value) : value;
        case AttributeTypes.DATE:
            return typeof value === 'string' ? value : value;
        case AttributeTypes.STRING:
        default:
            return String(value);
    }
};

const isAddAttributeEnabled = (selectedAttribute, attributeValue, newAttributeName = '', attributeType = '') => {
    const hasValidValue = attributeValue != null && attributeValue !== '';
    const isNew = selectedAttribute === 'create_new';
    return isNew ? newAttributeName && hasValidValue && attributeType : selectedAttribute && hasValidValue;
};

export {
    AttributeTypes,
    AttributeTypeLabels,
    AttributeTypeOptions,
    getAttributeTypeLabel,
    getAttributeTypeOptions,
    convertAttributeValueToType,
    isAddAttributeEnabled,
}; 